module.exports = __webpack_public_path__ + "static/media/pattern_design.fb7a38f0.png";